module.exports = __webpack_public_path__ + "img/LBA-Kalender.d9370e82.svg";